import { useState } from 'react';

/**
 * Manages the isEditing / saved / editable state triple for a single inline-editable field.
 *
 * @param {*} initialValue - The initial value from the server.
 * @param {function(*): Promise<void>} onSave - Called with the new value when the user saves.
 *   Should return a promise (e.g. mutateAsync). Thrown errors are caught; saved state is only
 *   updated on success.
 * @returns {{ value, isEditing, onChange, onEdit, onCancel, onSave }}
 */
export default function useEditableField(initialValue, onSave) {
  const [isEditing, setIsEditing] = useState(false);
  const [saved, setSaved] = useState(initialValue);
  const [editable, setEditable] = useState(initialValue);

  return {
    value: isEditing ? editable : saved,
    isEditing,
    onChange: setEditable,
    onEdit: () => { setEditable(saved); setIsEditing(true); },
    onCancel: () => { setEditable(saved); setIsEditing(false); },
    onSave: async () => {
      try {
        await onSave(editable);
        setSaved(editable);
        setIsEditing(false);
      } catch (error) {
        console.error('error saving field', error?.message);
      }
    },
  };
}
